<script lang="ts" setup>
  const props = withDefaults(
    defineProps<{
      accept?: string;
      modelValue: File | null;
      label?: string;
      isShort?: boolean;
      name?: string;
    }>(),
    {
      label: 'Upload a Document',
      isShort: false,
    },
  );
  const emit = defineEmits<{
    (e: 'update:modelValue', value: File | null): void;
  }>();

  const slots = useSlots();
  const fileInput = ref<HTMLInputElement>();
  const file = computed({
    get() {
      return props.modelValue;
    },
    set(value) {
      emit('update:modelValue', value);
    },
  });

  const { emitFormInput, emitFormChange, emitFormBlur } = useFormField(props);

  function onInputClick() {
    fileInput.value?.click();
  }

  function removeFile() {
    file.value = null;
    emitFormChange();
    emitFormBlur();
  }

  function uploadFile(e: Event) {
    const files = (e.target as HTMLInputElement)?.files;

    if (files && files.length) {
      file.value = files[0];
    }

    if (emitFormChange) {
      emitFormChange();
    }
  }
</script>

<template>
  <div
    :class="{ 'bg-white/5 p-[12px_10px]': !isShort }"
    class="flex flex-col items-start gap-3 self-stretch rounded-[10px]"
  >
    <p v-if="slots.description" class="text-white/60 font-barlow text-base not-italic font-normal leading-[150%]">
      <slot name="description"></slot>
    </p>

    <input
      ref="fileInput"
      class="invisible h-0"
      :accept="accept"
      type="file"
      @change="uploadFile"
      @input="emitFormInput"
      @blur="emitFormBlur"
    />

    <div class="w-full">
      <div
        class="flex h-[44px] px-4 py-[10px] font-semibold relative justify-center items-center gap-[10px] self-stretch rounded-[8px] bg-white/10 cursor-pointer"
        @click="onInputClick"
      >
        <template v-if="file">
          <div></div>
          <div class="text-white">
            {{ file.name }}
          </div>
          <SvgoCross class="absolute right-4 size-6" name="i-custom-cross" @click.stop="removeFile" />
        </template>

        <template v-else>
          <SvgoAdd name="i-custom-add" class="size-4" />
          <div class="text-white ml-10px">
            {{ label }}
          </div>
        </template>
      </div>
    </div>

    <p v-if="slots.hint" class="text-white/60 font-barlow text-base not-italic font-normal leading-[150%]">
      <slot name="hint"></slot>
    </p>
  </div>
</template>
